/**
 * API Configuration
 * Centralized configuration for all API endpoints and base URLs
 */

// Get API URL from env, ensure it ends with /api/v1
let apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1'

// Auto-fix: If URL doesn't end with /api/v1, append it
if (apiBaseUrl && !apiBaseUrl.endsWith('/api/v1')) {
  // Remove trailing slash if present
  apiBaseUrl = apiBaseUrl.replace(/\/$/, '')
  // Append /api/v1 if not already there
  if (!apiBaseUrl.endsWith('/api/v1')) {
    apiBaseUrl = `${apiBaseUrl}/api/v1`
  }
}

export const API_CONFIG = {
  BASE_URL: apiBaseUrl,
  TIMEOUT: 60000, // 60 seconds - increased for slower connections
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'ngrok-skip-browser-warning': 'true', // Required for ngrok
  },
}

/**
 * API Endpoints
 * All API endpoints are defined here for easy maintenance
 */
export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: '/operator/login',
    LOGOUT: '/operator/logout',
    ME: '/operator/me',
    REFRESH: '/operator/refresh',
  },

  // Operator Management
  OPERATOR: {
    METRICS: '/operator/metrics',
    CUSTOMERS: '/operator/customers',
    CUSTOMER_DETAIL: (orgId) => `/operator/customers/${orgId}`,
    EXTEND_TRIAL: (orgId) => `/operator/customers/${orgId}/extend-trial`,
    MARK_ACTIVE: (orgId) => `/operator/customers/${orgId}/mark-active`,
    UPDATE_NOTES: (orgId) => `/operator/customers/${orgId}/notes`,
    RESET_CUSTOMER: (orgId) => `/operator/customers/${orgId}/reset`,
  },

  // Operator Management (Internal)
  OPERATOR_MANAGEMENT: {
    LIST: '/operator/management',
    DETAIL: (id) => `/operator/management/${id}`,
    CREATE: '/operator/management',
    UPDATE: (id) => `/operator/management/${id}`,
    DELETE: (id) => `/operator/management/${id}`,
    TOGGLE_STATUS: (id) => `/operator/management/${id}/toggle-status`,
  },

  // Settings
  SETTINGS: {
    GET: '/settings',
    UPDATE: '/settings',
  },

  // Matching
  MATCHING: {
    RUN: '/matching/run',
    LIST: '/matching/list',
    APPROVE: (id) => `/matching/${id}/approve`,
    REJECT: (id) => `/matching/${id}/reject`,
  },
}

/**
 * Pagination defaults
 */
export const PAGINATION_DEFAULTS = {
  PAGE: 1,
  PER_PAGE: 10,
  PER_PAGE_OPTIONS: [10, 20, 50, 100],
}
